/// <reference types="./syncGetHeadEventId.d.ts" />
import { ok } from '@dossierhq/core';
import { queryNoneOrOne } from '../QueryFunctions.js';
export async function managementSyncGetHeadEventId(database, context) {
    const result = await queryNoneOrOne(database, context, 'SELECT uuid FROM events ORDER BY id DESC LIMIT 1');
    if (result.isError())
        return result;
    return ok(result.value?.uuid ?? null);
}
//# sourceMappingURL=syncGetHeadEventId.js.map